import { Link } from "react-router-dom";
import { MapPin, DollarSign, Briefcase, Sparkles, GraduationCap, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

const colorForType = (t) => {
  const map = {
    "part-time": "bg-nh-sky",
    "full-time": "bg-nh-mint",
    internship: "bg-nh-accent",
    volunteer: "bg-nh-pink",
    seasonal: "bg-orange-200",
    apprenticeship: "bg-purple-200",
    gig: "bg-emerald-200",
  };
  return map[t] || "bg-white";
};

function EligibilityBadge({ eligibility }) {
  if (!eligibility) return null;
  const map = {
    eligible: { icon: <CheckCircle2 size={12} />, cls: "bg-nh-mint", label: "Eligible" },
    review: { icon: <AlertTriangle size={12} />, cls: "bg-nh-accent", label: "Review" },
    not_eligible: { icon: <XCircle size={12} />, cls: "bg-red-200", label: "Not Eligible" },
  };
  const m = map[eligibility.level] || map.review;
  return <span className={`nh-tag ${m.cls}`} data-testid={`eligibility-${eligibility.level}`}>{m.icon}<span className="ml-1">{m.label}</span></span>;
}

export default function JobCard({ job, testIdPrefix = "job" }) {
  const pay = job.pay_min || job.pay_max
    ? `$${job.pay_min || 0}${job.pay_max ? `–$${job.pay_max}` : ""}/${(job.pay_period||"hr").slice(0,3)}`
    : (job.job_type === "volunteer" ? "Volunteer" : "Pay TBD");
  return (
    <Link to={`/jobs/${job.id}`} className="nh-card block p-5" data-testid={`${testIdPrefix}-card-${job.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className={`h-12 w-12 rounded-lg border-2 border-black flex items-center justify-center font-black text-lg ${colorForType(job.job_type)}`}>
            {(job.company_name || "N")[0]}
          </div>
          <div className="min-w-0">
            <h3 className="font-display font-extrabold text-lg leading-tight truncate">{job.title}</h3>
            <p className="text-sm text-nh-muted truncate">{job.company_name}</p>
          </div>
        </div>
        <div className="flex flex-col items-end gap-1 shrink-0">
          {job.featured && <span className="nh-tag bg-nh-accent">Featured</span>}
          <EligibilityBadge eligibility={job.eligibility}/>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2 text-xs">
        <span className="nh-tag bg-white"><Briefcase size={12} className="mr-1"/>{job.job_type}</span>
        <span className="nh-tag bg-white"><MapPin size={12} className="mr-1"/>{job.remote ? "Remote" : (job.location || "—")}</span>
        <span className="nh-tag bg-white"><DollarSign size={12} className="mr-1"/>{pay}</span>
        <span className="nh-tag bg-nh-mint"><GraduationCap size={12} className="mr-1"/>Ages {job.min_age}+</span>
        {!job.experience_required && <span className="nh-tag bg-nh-pink"><Sparkles size={12} className="mr-1"/>No experience</span>}
        {job.source && job.source !== "sample" && job.source !== "employer" && <span className="nh-tag bg-white">via {job.source}</span>}
      </div>

      <p className="mt-3 text-sm text-nh-muted line-clamp-2">{(job.description || "").replace(/<[^>]+>/g, "").slice(0,180)}</p>
    </Link>
  );
}
